module.exports = __webpack_public_path__ + "static/media/macbook_1.08032a8c.png";